import React, { useState, useEffect } from "react";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import "./CRMTableDynamic.scss";
import BaseCustomerTable from "../BaseCustomerTable/BaseCustomerTable";
import AccountActionsModal from "../AccountActionsModal/AccountActionsModal";
import DynamicTable from "../DynamicTable/DynamicTable";
import { AssignDeassignRoles } from "../../util/API/admin";

function createData(name, email, phone, address, country) {
  return { name, email, phone, address, country };
}

export default function CRMTableDynamic({
  userData, //Data from the API
  handleSelectedUser, //Function to handle the selected user
  selectedUser, //Selected user
  selectedUserData, //Selected user data
  targetID, //this is for the edit icon to be dynamic
  filterType,
  searchText,
  systemRoles,
  fetchTable
}) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openAccount, setOpenAccount] = useState(false);
  const [userHeader, setUserHeader] = useState("User");
  const [crmTable, setCrmTable] = useState(null);
  const [hasFetchedMore, setHasFetchedMore] = useState(false);

  let isAssociateAdmin = sessionStorage.getItem("isAssociateAdmin");
  let isLoanAdmin = sessionStorage.getItem("isLoanAdmin");
  let isSuperAdmin = sessionStorage.getItem("isSuperAdmin");
  let isAdmin = sessionStorage.getItem("isAdmin");

  const rows = userData?.map((name) => {
    return createData(
      name?.name,
      name?.email,
      name?.phone,
      name?.address,
      name?.country
    );
  });

  useEffect(() => {
    if (filterType || searchText) {
      setPage(0);
    }
  }, [filterType, searchText])

  const handleClose = () => {
    setOpenAccount(false);
  };

  //Function to handle the opening of the modal with the user data
  const handleOpen = (user, fullUserData) => {
    handleSelectedUser(user, fullUserData, 'settings');
    let firstName = fullUserData.firstName;
    let lastName = fullUserData.lastName;
    let id = fullUserData.id;
    setUserHeader(`${firstName} ${lastName} - ${id}`);
  };

  const pageCount = Math.ceil(rows.length / rowsPerPage);
  const pageNumbers = Array.from({ length: pageCount }, (_, index) => index);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    async function getTable() {
      let response = await fetch(`/tables/crmTable.json`);
      const tableData = await response.json();
      setCrmTable(tableData);
      setRowsPerPage(tableData.rowsPerPage);
    }
    getTable();
  }, [])

  const assignDeassign = async(merchantid, roleid) => {
    const response = await AssignDeassignRoles(merchantid, roleid, 0);
    return response
  }

  const handleLoadMore = async () => {
    if (!hasFetchedMore && page === pageNumbers.length - 1) {
      setHasFetchedMore(true);
      await fetchTable(rows.length + 100, page + 1, searchText);
    }
  };

  useEffect(() => {
    handleLoadMore()
    setHasFetchedMore(false); 
  }, [page]);

  return (
    <>
      <AccountActionsModal
        open={openAccount}
        handleClose={handleClose}
        selectedUserData={selectedUserData}
        selectedUser={selectedUser}
        userHeader={userHeader}
      />
      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        { crmTable && 
        <DynamicTable
        tableData={userData}
        tableSource={crmTable}
        handleSetting={handleOpen}
        handleEdit={handleSelectedUser}
        page={page} 
        targetID={targetID}
        roles={systemRoles}
        handleDeleteRole={assignDeassign}
        isAssociateAdmin={isAssociateAdmin}
        isLoanAdmin={isLoanAdmin}
        isAdmin={isAdmin}
        isSuperAdmin={isSuperAdmin}
        />
        }
        <BaseCustomerTable
          page={page}
          onPageChange={handleChangePage}
          pageNumbers={pageNumbers}
        />
      </TableContainer>
    </>
  );
}
